<div class="orders-history-component"
     #historyOrdens>
  <div class="header">
    <mat-icon class="icon-order"
              svgIcon="layers"></mat-icon>
    <span class="title">CONSULTA DE ORDENS</span>
    <mat-icon class="close-btn"
              (click)="closeDialog()"
              svgIcon="close"></mat-icon>
  </div>
  <div class="header-options"
       [ngClass]="[selectedTab==0 ? 'one-line-filter' : '',  selectedTab==1 ? 'double-line-filter' : '']">
    <div class="network-error-message-oms"
         *ngIf="!statusOmsOnline">{{ msgStatusOmsOffile }}</div>
    <div class="row header-tabs">
      <div class="tab"
           [ngClass]="{'0':'selected-tab'}[selectedTab]"
           (click)="changeScreen(0)">Ordens do dia</div>
      <div class="tab"
           [ngClass]="{'1':'selected-tab'}[selectedTab]"
           (click)="changeScreen(1)">Histórico geral</div>
    </div>
    <div class="row header-filter">
      <div class="col-10">
        <div class="row">
          <div class="col-2">
            <mat-form-field>
              <mat-select panelClass="order-history-filter-select"
                          [disableOptionCentering]='true'
                          placeholder="status"
                          [(value)]="model.status">
                <mat-option *ngFor="let status of statusFilter"
                            [value]="status.descFilter">{{ status.descFilter }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field>
              <mat-select panelClass="order-history-filter-select"
                          [disableOptionCentering]='true'
                          placeholder="tipo"
                          [(value)]="model.type">
                <mat-option *ngFor="let status of typeFilter"
                            [value]="status.descFilter">{{ status.descFilter }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field>
              <mat-select panelClass="order-history-filter-select"
                          [disableOptionCentering]='true'
                          placeholder="direção"
                          [(value)]="model.direction">
                <mat-option *ngFor="let status of buySellFilter"
                            [value]="status.descFilter">{{ status.descFilter }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <mat-select panelClass="order-history-filter-select"
                          [disableOptionCentering]='true'
                          placeholder="mercado"
                          [(value)]="model.market">
                <mat-option *ngFor="let status of MarketFilter"
                            [value]="status.descFilter">{{ status.descFilter }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <app-auto-complete [placeHolderSetter]="'ativo'"
                               [hideCompany]='true'
                               [symbolAutoComplete]="model.symbol"
                               #issuingAsset
                               id="issuingAsset"
                               (rawInformation)="checkForBlank($event)"
                               (onsymbolChanged)="selectAsset($event)"></app-auto-complete>
          </div>
        </div>
        <div class="row mt-2">
          <div *ngIf="selectedTab == 1"
               class="col-4 date-range">
            <div class="upper-text">selecione o período desejado</div>
            <div class="">
              <ngbd-datepicker-range [maxDateToday]='true'
                                     [reset]="changingValue"
                                     (dateIni)="changeDateIni($event)"
                                     (dateFin)="changeDateFim($event)">
              </ngbd-datepicker-range>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 button-box">
        <button mat-raised-button
                class="xs"
                (click)="clearFilter()">LIMPAR</button>
        <button mat-raised-button
                class="xs white"
                (click)="selectedTab == 0 ? onSearchDaily(): onSearchHistory()">FILTRAR</button>
      </div>
    </div>
  </div>
  <div class='table'
       [ngClass]="[selectedTab==0 ? 'calc-height-1' : '',  selectedTab==1 ? 'calc-height-2' : '']">
    <div class="table-header">
      <div class="header-item"
           (click)="sortBy('stateName')"
           style="width: 12%;">
        Status
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'stateName'"
                  class="sort-arrow">arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'stateName'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
      <div class="header-item"
           (click)="sortBy('quote')"
           style="width: 8%;">Ativo
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'quote'"
                  class="sort-arrow">arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'quote'"
                  class="sort-arrow">arrow_upward</mat-icon>
      </div>
      <div class="header-item"
           style="width: 7%;"
           (click)="sortBy('type')">Tipo
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'type'"
                  class="sort-arrow">arrow_downward</mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'type'"
                  class="sort-arrow">arrow_upward</mat-icon>
      </div>
      <div class="header-item"
           style="width: 10%;"
           (click)="sortBy('mercado')">Mercado
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'mercado'"
                  class="sort-arrow">arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'mercado'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
      <div class="header-item text-center"
           style="width: 7%;"
           (click)="sortBy('buyOrSell')">Direção
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'buyOrSell'"
                  class="sort-arrow">arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'buyOrSell'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
      <div class="header-item text-right"
           style="width: 7%;"
           (click)="sortBy('quantitySupplied')">Qtd.
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'quantitySupplied'"
                  class="sort-arrow">
          arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'quantitySupplied'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
      <div class="header-item text-right"
           style="width: 8%;"
           (click)="sortBy('quantityExecuted')">Exec.
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'quantityExecuted'"
                  class="sort-arrow">
          arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'quantityExecuted'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
      <div class="header-item text-right"
           style="width: 10%;"
           (click)="sortBy('quantityRemaining')">Restante
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'quantityRemaining'"
                  class="sort-arrow">
          arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'quantityRemaining'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
      <div class="header-item text-right"
           style="width: 8%;"
           (click)="sortBy('price')">Preço
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'price'"
                  class="sort-arrow">arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'price'"
                  class="sort-arrow">arrow_upward</mat-icon>
      </div>
      <div class="header-item text-right"
           style="width: 9%;"
           (click)="sortBy('priceAverage')">P. Médio
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'priceAverage'"
                  class="sort-arrow">arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'priceAverage'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
      <div class="header-item text-right"
           style="width: 14%;"
           (click)="sortBy('transactTime', 'date')">Data/Hora
        <mat-icon *ngIf="filterDirection == 1 && currentFilter == 'transactTime'"
                  class="sort-arrow">arrow_downward
        </mat-icon>
        <mat-icon *ngIf="filterDirection == 2 && currentFilter == 'transactTime'"
                  class="sort-arrow">arrow_upward
        </mat-icon>
      </div>
    </div>
    <div class="table-body">
      <div class="spinner"
           *ngIf="loading">
        <app-spinner-loading></app-spinner-loading>
      </div>
      <table class="table-orders"
             id="table-orders">
        <tbody>
          <ng-template *ngIf='!loading && orderList?.length >= 0'
                       class="row-template"
                       ngFor
                       let-element
                       [ngForOf]="orderList"
                       let-i="index">
            <tr class="table-row-height"
                [ngClass]="(i % 2 === 0) ? 'even' : 'odd'"
                id="tr{{i}}"
                (click)="i !== idDetails ? openDetail(i) : closeDetail(i)">
              <td style="width: 12%;">
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="i !== idDetails"
                            class="pointer arrow">keyboard_arrow_down</mat-icon>
                  <mat-icon *ngIf="i === idDetails"
                            class="pointer arrow">keyboard_arrow_up</mat-icon>
                  <span [ngClass]="{ '0':'status-default', '1':'status-success', '2':'status-success', '4':'status-error',
                    '5':'status-default', '6':'status-error', '8':'status-error', '9':'status-error', 'A':'status-default',
                    'C':'status-error', 'E':'status-warning'} [element.stateCode]">
                    {{element.state}}</span>
                </div>
              </td>
              <td style="width: 8%;">{{element.quote}}</td>
              <td style="width: 7%;">{{element.type}}</td>
              <td style="width: 10%;">{{selectTab == 0 ? element.mercado : element.mercado }}</td>
              <td class="text-center"
                  style="width: 7%;"
                  [ngClass]="{'text-buy': element.buyOrSell === 'Compra', 'text-sell': element.buyOrSell === 'Venda'}">
                {{element.buyOrSell === 'Compra' ? 'C' : 'V'}} </td>
              <td class="text-right"
                  style="width: 7%;">{{element.quantitySupplied | number:'0.2-2':'pt'}}</td>
              <td class="text-right"
                  style="width: 8%;">{{element.quantityExecuted | number:'0.2-2':'pt'}}</td>
              <td class="text-right"
                  style="width: 10%;">{{element.quantityRemaining | number:'0.2-2':'pt'}}</td>
              <!-- TODO: ORDEM STOP -->
              <td class="text-right"
                  style="width: 10%;"
                  *ngIf="element.type === 'Stop'">
                {{element.mercado === 'Bovespa' ? (element.priceStop | number) :
                (element.priceStop).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2 }) }}
              </td>
              <!-- TODO: ORDEM LIMITADA & MERCADO -->
              <td class="text-right"
                  style="width: 8%;"
                  *ngIf="element.type !== 'Stop'">
                {{element.mercado === 'Bovespa' ? (element.price | number) : (element.price |
                number).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2 }) }}
              </td>
              <td class="text-right"
                  style="width: 9%;">
                {{element.mercado === 'Bovespa' ? (element.priceAverage | number) :
                ( (element.priceAverage / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2,
                maximumFractionDigits: 2 })) }}
              </td>
              <td class="text-right"
                  style="width: 14%;">{{element.transactTime}}
                <div class="gradient-options">
                  <mat-icon *ngIf="openStatus.generic.includes(element.state) && element.stateCode !== 'A'"
                            svgIcon="edit-2"
                            (click)="openEditOrder(i, $event)"
                            class="icon-options "
                            title="Editar Ordem"
                            #tooltipMin="matTooltip"
                            matTooltipClass="order-detail-action-tooltip"
                            matTooltipPosition="above"
                            matTooltip="Editar Ordem"></mat-icon>
                  <mat-icon *ngIf="openStatus.generic.includes(element.state)"
                            svgIcon="close"
                            (click)="cancelOrder(element, $event)"
                            class="icon-options"
                            title="Cancelar Ordem"
                            #tooltipMin="matTooltip"
                            matTooltipClass="order-detail-action-tooltip"
                            matTooltipPosition="above"
                            matTooltip="Cancelar Ordem">
                  </mat-icon>
                  <mat-icon *ngIf="element.stateCode !== 0 || element.stateCode !== 1 || element.stateCode !== 5 || element.stateCode !== 6 || element.stateCode !== 9 || element.stateCode !== 'A' || element.stateCode !==  'E' || element.stateCode !== 'R'"
                            (click)="reSendOrder(element, $event)"
                            svgIcon="corner-up-left"
                            class="icon-options"
                            title="Reenviar Ordem"
                            #tooltipMin="matTooltip"
                            matTooltipClass="order-detail-action-tooltip"
                            matTooltipPosition="above"
                            matTooltip="Reenviar Ordem"></mat-icon>
                </div>
              </td>
            </tr>
            <tr class="details"
                [ngClass]="(i % 2 === 0) ? 'even' : 'odd'"
                id="trd{{i}}">
              <td colspan="12">
                <div *ngIf="idDetails === i"
                     [@animateDetails]="stateDetails"
                     [@animateDetailsClose]="stateDetailsClose">
                  <app-orders-history-detail [dataOrder]="element"></app-orders-history-detail>
                </div>
                <div *ngIf="idEdit === i"
                     [@animateDetails]="stateDetails"
                     [@animateDetailsClose]="stateDetailsClose">
                  <app-edit-order (close)="closeEditOrder(i)"
                                  [dataOrder]="element"></app-edit-order>
                </div>
              </td>
            </tr>
          </ng-template>
          <div class="empty"
               *ngIf="!loading && orderList?.length <= 0 && (selectedTab === 0 || wasHistoryFetched)">
            <app-empty-result [message]="msgNoOrdersFound"></app-empty-result>
          </div>
        </tbody>
      </table>
    </div>
  </div>